import { ScreenLoadingFallback } from '@/src/components/ui/ScreenLoadingFallback'

import {
  PostPaymentOnboardingProvider,
  usePostPaymentOnboardingContext,
} from './post-payment-onboarding/PostPaymentOnboardingContext'
import { PostPaymentOnboardingStepContent } from './post-payment-onboarding/PostPaymentOnboardingStepContent'

export default function PostPaymentOnboardingScreen() {
  return (
    <PostPaymentOnboardingProvider>
      <PostPaymentOnboardingScreenContent />
    </PostPaymentOnboardingProvider>
  )
}

function PostPaymentOnboardingScreenContent() {
  const { isLoading } = usePostPaymentOnboardingContext()

  if (isLoading) {
    return <ScreenLoadingFallback />
  }

  return <PostPaymentOnboardingStepContent />
}
